import React from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";

const socials = [
  { icon: BsTwitter, href: "https://twitter.com/NishanN17731363", label: "Twitter" },
  { icon: FaFacebook, href: "https://www.facebook.com/nishanneupane.pro", label: "Facebook" },
  { icon: BsInstagram, href: "https://www.instagram.com/nishanneupane00", label: "Instagram" },
];

const SocialMedia = ({ compact = false }) => {
  const sizeClass = compact ? "w-11 h-11" : "w-12 h-12";

  return (
    <div
      className={`flex ${compact ? "flex-row gap-3" : "flex-col gap-3"} bg-white/5 backdrop-blur-xl border border-white/10 rounded-full p-2 shadow-glow`}
    >
      {socials.map(({ icon: Icon, href, label }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          className={`${sizeClass} rounded-full flex items-center justify-center text-slate-100 bg-white/5 hover:bg-primary/90 hover:text-white transition-all duration-200 hover:-translate-y-1`}
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
};

export default SocialMedia;
